import { StaticQuery, graphql } from "gatsby"
import React from "react"

import { Bounds } from "../grid"
import PlanItem from "../pricingTable/item-hamdeli"
import { colors } from "../../utils/styleVariables"
import { setColor } from "../../utils/styleFunctions"
import { H4 } from "../../components/typography"

class RenderComponent extends React.Component {
  render() {
    const { yaml, images } = this.props.data
    const { planData, planFeatures } = yaml.content
    const imagesEnum = {}

    planData.price = planData.pricing
    planData.to = planData.link

    images.nodes.forEach(image => {
      const name = image.image.fluid.originalName.split(".")[0]
      imagesEnum[name] = image.image
    })

    return (
      <Bounds halign="center" direction="vertical">
        <div style={{ marginBottom: "10px" }}>
          <span>
            <H4>کد تخفیف ۱۰۰٪: </H4>
          </span>
          <span
            style={{
              backgroundColor: "#414141",
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
              padding: "4px",
            }}
          >
            <H4 style={{ color: "white", marginBottom: "0px" }}>HAMDELI</H4>
          </span>
        </div>
        <PlanItem
          handleOpened={this.handleOpened}
          opened={true}
          plan={planData[0]}
          planFeatures={planFeatures}
          desktopWidth="100%"
          tabletWidth="100%"
          baseWidth="100%"
          style={{
            backgroundColor: setColor(colors.lightBlue, 0.4),
          }}
        />
        <div style={{ marginTop: "10px" }}>
          <span>
            <H4>کد تخفیف ۱۰۰٪: </H4>
          </span>
          <span
            style={{
              backgroundColor: "#414141",
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
              padding: "4px",
            }}
          >
            <H4 style={{ color: "white", marginBottom: "0px" }}>HAMDELI</H4>
          </span>
        </div>
      </Bounds>
    )
  }
}

const PricingTable = () => (
  <StaticQuery
    query={graphql`
      {
        yaml: contentYaml(header: { slug: { eq: "/hamdeli" } }) {
          content {
            planData {
              description
              pricing
              slug
              storage
              sub
              title
              services {
                blog
                products
                gateway
                freeDomain
                discountCode
                pageBuilder
                menuBuilder
                advancedSearch
                telegramBot
                sslCrt
              }
              button {
                text
                link
                icon
              }
            }
            planFeatures {
              blog
              products
              gateway
              freeDomain
              discountCode
              pageBuilder
              menuBuilder
              advancedSearch
              telegramBot
              sslCert
            }
          }
        }
        images: allFile(filter: { relativePath: { regex: "/plans/" } }) {
          nodes {
            image: childImageSharp {
              fluid {
                originalName
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    `}
    render={data => <RenderComponent data={data} />}
  />
)

export default PricingTable
